import { Component } from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-profile',
  template: `
    <app-bar
      i18n-title="Secondary navigation my profile bar title"
      title="My Profile"
      link="/me"
      flTrackingSection="SubnavProfile">
      <!-- Considering this subnav is only shown on self user's profile page
        just highlight Improve Profile permanently -->
      <app-bar-item
        link="/me"
        i18n="Secondary navigation my profile bar item"
        flTrackingLabel="ImproveProfile"
        [linkIsActive]="true"
      >
        Improve Profile
      </app-bar-item>
      <app-bar-item
        link="/services/dashboard.php"
        [exactLink]="true"
        i18n="Secondary navigation my profile bar item"
        flTrackingLabel="MyServices"
      >
        My Services
      </app-bar-item>
      <app-bar-item
        link="/exam/exams/index.php"
        [exactLink]="true"
        i18n="Secondary navigation my profile bar item"
        flTrackingLabel="GetCerified"
      >
        Get Certified
      </app-bar-item>
      <app-bar-item
        link="/hireme"
        [exactLink]="true"
        i18n="Secondary navigation my profile bar item"
        flTrackingLabel="PromoteProfile"
      >
        Promote Profile
      </app-bar-item>
      <app-bar-item
        link="/users/game"
        [exactLink]="true"
        i18n="Secondary navigation my profile bar item"
        flTrackingLabel="MyRewards"
      >
        My Rewards
      </app-bar-item>
      <fl-button
        [color]="ButtonColor.PRIMARY"
        link="/post-project"
        i18n="Secondary navigation my profile bar post project button"
        flTrackingLabel="PostProjectButton"
      >
        Post a Project
      </fl-button>
    </app-bar>
  `,
})
export class NavigationSecondaryProfileComponent {
  ButtonColor = ButtonColor;
}
